"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var s = _interopRequireWildcard(require("./PaginationBreadcrumbs.style"));

var _default = function _default(_ref) {
  var label = _ref.label,
      current = _ref.current,
      _onClick = _ref.onClick,
      theme = _ref.theme;
  var isSelected = label === current;
  return _react.default.createElement("div", {
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      return _onClick(label);
    },
    className: s.pageButton(theme, isSelected, label + 1)
  }, label + 1);
};

exports.default = _default;